import { forwardRef, Th, Tr } from "@chakra-ui/react";

export const ResidenceTypeHeaderRow = forwardRef((props, ref: React.ForwardedRef<HTMLTableRowElement>) => <Tr ref={ref}>
  <Th>Afbeelding</Th>
  <Th>Naam</Th>
  <Th>Status</Th>
  <Th>Acties</Th>
</Tr>);
